import * as React from 'react';
import { ChevronRight } from 'react-feather';
import { InternalLink } from './InternalLink';
import { TodoItemCheckbox } from './TodoItemCheckbox';

interface Props {
  linkTo: string;
  complete: boolean;
}

export const TodoItem: React.FC<Props> = ({ linkTo, children, complete }) => {
  return (
    <li>
      <InternalLink
        to={linkTo}
        className={`w-full flex justify-between ${
          complete ? '' : 'text-grey-500 hover:text-grey-600'
        }`}
      >
        <div className="flex items-center">
          <TodoItemCheckbox complete={complete} className="mr-2" />
          <span>{children}</span>
        </div>
        <ChevronRight className="text-grey-600" />
      </InternalLink>
    </li>
  );
};
